module.exports = __webpack_public_path__ + "static/media/alarm.296e4ce5.svg";